import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class Intercept404Service implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<string>> {
    return next.handle(req).pipe(
      catchError((err) => {
        switch (err.status) {
          case 403:
          case 404:
            this.router.navigateByUrl('/error404').then();
            return EMPTY;
          default:
            return throwError(err);
        }
      })
    );
  }
}
